// eslint-disable-next-line
import { Route } from 'vue-router';

export default {
  data() {
    return { transitionEnterClass: 'fadeIn', transitionLeaveClass: 'fadeOut' };
  },
  methods: {
    /**
     * updates page transition classes before the route update
     * @param {Route} to
     * @param {Route} from
     */
    updatePageTransition(to, from) {
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      if (toDepth > fromDepth) {
        this.transitionEnterClass = 'fadeIn';
        this.transitionLeaveClass = 'fadeOut';
      } else {
        this.transitionEnterClass = 'fadeIn';
        this.transitionLeaveClass = 'fadeOut';
      }
    }
  }
};
